import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/uptime/inline/byKey/uptime.inline.byKey.query.gql"
import type {
  UptimeInlineByKeyQuery,
  UptimeInlineByKeyQueryVariables,
} from "@/v2-backoffice-client/uptime/inline/byKey/__types__/uptime.inline.byKey.query"

type Options = QueryHookOptions<
  UptimeInlineByKeyQuery,
  UptimeInlineByKeyQueryVariables
>

export function useUptimeInlineByKeyQuery(options?: Options) {
  return useQuery<UptimeInlineByKeyQuery, UptimeInlineByKeyQueryVariables>(
    query,
    options,
  )
}
